// extracted by mini-css-extract-plugin
export var inputContainer = "autocomplete-module--inputContainer--+CUEj";